import Api from 'services/Api';

const update = (id, data, reducer, url, callback, callBackWithDispatch) => {
	return (dispatch) => {
		dispatch({
			type: reducer.FETCHING_ONCE,
		});
		Api.put(
			data,
			url + '/' + id,
			(error, data) => {
				if (typeof callback === 'function' && !error) {
					callback(data);
				}
				if (error) {
					return dispatch({
						type: reducer.ERROR_ONCE,
						payload: {
							message: data,
						},
					});
				}

				dispatch({
					type: reducer.UPDATE_COLLECTION,
					payload: {
						item: data,
						type: 'update'
					}
				});

				if (typeof callBackWithDispatch === 'function') {
					callBackWithDispatch(dispatch, data);
				}

				return dispatch({
					type: reducer.GET_ONCE,
					payload: {
						props: data
					}
				});
			}
		);
	};
};
export default update;
